import Reveal from '@/pages/zz-review/components/Reveal';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-16 md:py-24 bg-background-50 scroll-mt-20">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <Reveal>
          <p className="text-xs tracking-[0.2em] uppercase text-foreground-400 mb-3">
            計畫發起與團隊聯繫
          </p>
          <h2
            className="text-2xl md:text-4xl text-foreground-900 mb-5"
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            發起與聯絡
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto mb-8">
            本專案由達太聯王股份有限公司（GAPICS Inc.）發起，堅持以最高規格之內容與履約品質回饋贊助者。
          </p>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3 sm:gap-4">
            <a
              href="https://aum1001matrix.org"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="whitespace-nowrap flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-200/70 bg-background-100 text-foreground-700 text-sm md:text-base hover:bg-background-200/70 transition-colors cursor-pointer"
            >
              <i className="ri-global-line text-base" />
              官方網站
            </a>
            <a
              href="mailto:service@aum1001matrix.org"
              className="whitespace-nowrap flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-200/70 bg-background-100 text-foreground-700 text-sm md:text-base hover:bg-background-200/70 transition-colors cursor-pointer"
            >
              <i className="ri-mail-line text-base" />
              service@aum1001matrix.org
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}